import React from 'react';
import { HeartIcon } from 'lucide-react';
const items = ['Te sientes abrumada con el desorden.', 'Quieres organizarte, pero no sabes por dónde empezar.', 'Sientes que cargas muchas responsabilidades.', 'Necesitas una guía sencilla y en español.', 'Quieres recuperar calma en tu hogar.', 'Quieres sentir más control de tu tiempo.', 'Estás en una nueva etapa de vida y quieres empezar diferente.', 'No quieres métodos complicados ni perfectos.', 'Necesitas algo práctico, cálido y fácil de seguir.'];
export function ForYou() {
  return <section className="w-full bg-cream px-5 py-20 sm:px-8 sm:py-28" data-id="element-32" data-mp="3lrv6d7ys8nyc">
      <div className="mx-auto grid max-w-5xl gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20" data-id="element-33" data-mp="3jm4dlty45rn">
        <header data-id="element-34" data-mp="3vp9k2ztbmymy">
          <p className="text-[0.7rem] uppercase tracking-[0.22em] text-clay" data-id="element-35" data-mp="3vopztcg77y5r">
            Para quién es
          </p>
          <h2 className="mt-4 font-serif text-4xl leading-tight text-ink sm:text-5xl" data-id="element-36" data-mp="25dbztcfqlwcd">
            Este ebook es para ti si…
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-cocoa" data-id="element-37" data-mp="348qkfzw30t21">
            Si te reconoces en al menos tres de estas frases, este plan fue
            escrito pensando en ti.
          </p>
        </header>

        <ul className="space-y-4" data-id="element-38" data-mp="3e53nhodioj9g">
          {items.map(item => <li key={item} className="flex items-start gap-4 border-b border-sand pb-4 text-lg text-cocoa last:border-b-0" data-id="element-39" data-mp="3iwlepkpqn5h8">
              <HeartIcon className="mt-1.5 h-4 w-4 shrink-0 text-terracotta" aria-hidden="true" data-id="element-40" data-mp="3ny0zdbo079z3" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}